// extracted by mini-css-extract-plugin
module.exports =  {"reply":"Reply-mt6N__reply","sender":"Reply-HYhm__sender"};